module.exports = __webpack_public_path__ + "static/media/cartoes_mastercard.c02d9180.svg";